import { useQueryClient } from '@tanstack/react-query';

import { useGraphQlMutation, useGraphQlQuery } from '../../../data/util';
import { QueryKeys } from '../../queries/common';
import {
  projectHarmonizationPropertiesQuery,
  ProjectHarmonizationPropertiesResponse,
  updateHarmonizationStatusMutation
} from '../../queries/project';
import { HarmonizationStatus } from '../../types';

export function useProjectHarmonizationProperties(projectId: string, enabled = true) {
  const { data, ...rest } = useGraphQlQuery<ProjectHarmonizationPropertiesResponse, { projectId: string }>(
    [QueryKeys.Project, 'ProjectHarmonizationProperties', { projectId }],
    projectHarmonizationPropertiesQuery,
    { enabled: enabled && Boolean(projectId) },
    { projectId }
  );

  return {
    harmonizationProperties: data?.Project?.harmonizationProperties ?? null,
    ...rest
  };
}

export function useUpdateHarmonizationStatus(projectId?: string) {
  const queryClient = useQueryClient();
  const { mutateAsync, ...rest } = useGraphQlMutation<number, { uid: string; status: `${HarmonizationStatus}` }>(
    updateHarmonizationStatusMutation,
    {
      onSuccess: () => {
        if (projectId) {
          queryClient.invalidateQueries([QueryKeys.Project, 'ProjectHarmonizationProperties', { projectId }]);
        }
      }
    }
  );

  return {
    updateHarmonizationStatus: mutateAsync,
    ...rest
  };
}
